<template>
  <div class="lightList-content" v-loading="loading">
    <el-form ref="form" :model="pageInfo" label-width="auto" class="search_head">
      <el-row :gutter="20" class="list-head">
        <el-col :span="3">
          <el-form-item label="协议类型">
            <el-select
              placeholder="选择协议类型"
              v-model="pageInfo.lamp_protocol"
              style="width: 100%"
              @change="selectChange"
              class="light-select"
            >
              <el-option
                v-for="t in protocolList"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="设备识别号">
            <el-input v-model="pageInfo.lamp_number" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="设备别名">
            <el-input v-model="pageInfo.lamp_name" />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="选择灯组">
            <el-select
              clearable
              placeholder="请选择分灯组"
              v-model="pageInfo.lamp_group"
              style="width: 100%"
            >
              <el-option
                v-for="t in groupList"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="在线状态">
            <el-select
              clearable
              placeholder="选择状态"
              v-model="pageInfo.ste"
              style="width: 100%"
            >
              <el-option
                v-for="t in stateList"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
            <el-button type="primary" icon="el-icon-search" @click="headSearch" size="mini" round>检索</el-button>
            <el-button type="info" @click="headReset" size="mini" round>重置</el-button>
        </el-col>
        <el-col :span="2" style="padding:0;">
          <el-button type="primary" @click="allOpen.visible = true" round>全开</el-button>
          <el-button type="info"  @click="lightContorl(0)" round>全关</el-button>
        </el-col>
        <el-col :span="2" class="control">
          <div class="show_head" @click="headShow(head_show)">
            <template v-if="head_show">收起 <i class="el-icon-arrow-up"></i></template>
            <template v-else>展开 <i class="el-icon-arrow-down"></i></template>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="head_other" v-show="head_show">
      <el-row :gutter="20" class="head_other_row">
        <el-col :span="6" class="control_type">
          <div class="other_text">批量设置路灯模式</div>
          <el-button type="primary" @click="contorlType(0)" round>全自动</el-button>
          <el-button type="info"  @click="contorlType(1)" round>全手动</el-button>
        </el-col>

        <el-col :span="6" class="control_type">
          <div class="other_text">批量导入</div>
          <el-button type="primary" @click="exportFile.visible = true" round>开始导入</el-button>
          <div class="other_text"><a href="https://www.forido.net/static/upload/xlsx/模板.xlsx" target="_blank">下载模板文件</a></div>
        </el-col>


      </el-row>
    </div>

    <div class="clear"></div>
    <div class="boder-grey"></div>
    <div class="h20"></div>
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%" stripe>
      <el-table-column
        prop="number"
        label="设备识别号"
        width="160"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="设备别名"
        width="200"
        align="center"
        stripe
      ></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column
        prop="stg_name"
        label="当前策略"
        align="center"
      ></el-table-column>
      <el-table-column label="亮度控制" align="center" v-if="pageInfo.lamp_protocol!='2'">
        <template slot-scope="scope">
          <i
            class="el-icon-setting pointer mar-r5"
            @click="showSet(scope.row)"
          ></i>
          <span>{{ msType[scope.row.ms] }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="current"
        label="电流(A)"
        width="120"
        align="center"
        v-if="pageInfo.lamp_protocol!='2'"
      ></el-table-column>
      <el-table-column
        prop="voltage"
        label="电压(V)"
        width="120"
        align="center"
        v-if="pageInfo.lamp_protocol!='2'"
      ></el-table-column>
      <el-table-column
        prop="light"
        label="亮度(%)"
        align="center"
      ></el-table-column>
      
      <el-table-column prop="is_double" label="倾斜角(X°/Y°)" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.is_angle">{{scope.row.x_angle}}°/{{scope.row.y_angle}}°</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="角度校正(相对/绝对)"
        prop="type"
        width="80"
        align="center"
        >
        <template slot-scope="scope">
            <el-switch
              v-model="scope.row.angle_type"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
              @change="changeAngle(scope.row.lamp_id,$event)"
              v-if="scope.row.is_angle"
              />
              <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        prop="ste"
        width="140"
        align="center"
        v-if="pageInfo.lamp_protocol!='2'"
        sortable
      >
        <template slot-scope="scope">
          <i :class="steColorType[scope.row.ste]"></i>
          <span>{{ steType[scope.row.ste] }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="是否首页显示" prop="type" sortable v-if="pageInfo.lamp_protocol=='1'">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.type"
            :active-value="1"
            :inactive-value="0"
            active-color="#67C23A"
            inactive-color="#aaaaaa"
            @change="changeSetHome(scope.row.lamp_id, scope.row.type)"
          />
        </template>
      </el-table-column> -->
      <el-table-column prop="edit" label="编辑" fixed="right">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="deleteLamp(scope.row.lamp_id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    <!-- 编辑路灯信息弹窗 -->
    <el-dialog 
      :title="editType === 'create' ? '添加路灯' : '修改路灯'"
      :visible.sync="dialogVisible">
      <el-form
        :model="editLamp"
        label-position="left"
        label-width="80px"
        :rules="editLampRule"
        ref="lampInfo"
      >
        <el-row :gutter="20" class="item-list">
          <el-col :span="12">
            <el-form-item label="设备别名" prop="name">
              <el-input v-model="editLamp.name"></el-input>
            </el-form-item>
            <el-form-item label="选择协议">
              <el-select
                clearable
                placeholder="请选择协议"
                v-model="editLamp.lamp_type"
                style="width: 100%"
              >
                <el-option
                  v-for="t in protocolList"
                  :key="parseInt(t.id)"
                  :label="t.name"
                  :value="parseInt(t.id)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备号" prop="number">
              <el-input v-model="editLamp.number"></el-input>
            </el-form-item>
            <el-form-item label="网关编号" prop="gateway">
              <el-input v-model="editLamp.gateway"></el-input>
            </el-form-item>
            <el-form-item label="sim卡号" prop="sim">
              <el-input v-model="editLamp.sim"></el-input>
            </el-form-item>
            <el-form-item label="选择灯组">
              <el-select
                clearable
                placeholder="请选择灯组"
                v-model="editLamp.lamp_group"
                style="width: 100%"
              >
                <el-option
                  v-for="t in groupList"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="经度" prop="longitude">
                  <el-input v-model="editLamp.longitude" @input="onInput()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="纬度" prop="latitude">
                  <el-input v-model="editLamp.latitude" @input="onInput()"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="地址" prop="address">
              <el-input class="address" v-model="editLamp.address"></el-input>
            </el-form-item>
            
          </el-col>
          <el-col :span="12">
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="map-container">
                  <el-amap
                    ref="map"
                    vid="amap"
                    :center="myMap.center"
                    :zoom="myMap.zoom"
                    :plugin="myMap.plugin"
                    class="amap-demo"
                    mapStyle="amap://styles/light"
                    :events="myMap.events"
                  >
                    <el-amap-circle-marker
                      :center="myMap.markercenter"
                      :radius="myMap.radius"
                      fillColor="gray"
                      strokeColor="#fff"
                      :fillOpacity="myMap.fillOpacity"
                    >
                    </el-amap-circle-marker>
                  </el-amap>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑路灯亮度设置 -->
    <div
      class="box_control_bg"
      v-if="lightSetItem.lightSetVisible"
      @click="closeSet"
    ></div>
    <div class="box_control" v-if="lightSetItem.lightSetVisible">
      <div class="box_head">
        <span class="box_title">{{ lightSetItem.title }}-亮度控制</span>
        <div class="box_close" @click="closeSet">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <light-set
          ref="lightSet"
          :setData="lightSetItem.lightSetData"
          @updated="getTableData(pageInfo.page)"
        ></light-set>
      </div>
    </div>

    <!-- 全开-亮度控制 -->
    <el-dialog class="dialog600" title="全开-亮度控制" :visible.sync="allOpen.visible">
      <div class="box_body">
        <el-slider
          v-model="allOpen.light"
          :min="1"
          :max="100"
          show-input
          @change="manualChange = true"
        ></el-slider>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="allOpen.visible = false,allOpen.visible = false,allOpen.light = 0">取 消</el-button>
        <el-button type="primary" @click="(allOpen.visible = false), lightContorl(1)"
          >确 定</el-button
        >
      </div>
    </el-dialog>

     <!-- 批量导入 -->
    <el-dialog class="dialog600" title="批量导入" :visible.sync="exportFile.visible">
      <div class="box_body">
        <el-form
          :model="exportFile"
          label-position="left"
          label-width="100px"
        >
          <el-form-item label="所属用户" prop="id">
            <el-select
              clearable
              filterable
              placeholder="选择所属用户"
              v-model="exportFile.id"
              style="width: 100%"
            >
              <el-option
                v-for="t in adminList"
                :key="parseInt(t.id)"
                :label="t.username"
                :value="parseInt(t.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="路灯协议">
            <el-select
              clearable
              placeholder="请选择协议"
              v-model="exportFile.lamp_type"
              style="width: 100%"
            >
              <el-option
                v-for="t in protocolList"
                :key="parseInt(t.id)"
                :label="t.name"
                :value="parseInt(t.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件上传">
            <el-upload
              ref="upload"
              name="file"
              :action="uploadAction()"
              :limit="1"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :on-success="handleAvatarSuccess"
              :beforeUpload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
          </el-form-item>
          </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportExcel(0)">取 消</el-button>
        <el-button type="primary" @click="exportExcel(1)"
          >确 定</el-button
        >
      </div>
    </el-dialog>

  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList"
import adminsApi from "@/api/auth/admins";
import lightSet from "@/components/light/device"
import lightGroupApi from "@/api/light/lampGroup"
import store from '@/store'
export default {
  components: {
    lightSet,
  },
  data() {
    const vm = this;
    return {
      myMap: {
        center: store.state.user.account.center,
        markercenter: store.state.user.account.center,
        events: {
          mapmove: () => {
            this.handleMove();
          },
        },
        zoom: 18,
        radius: 10,
        fillOpacity: 1,
      },
      loading: false,
      protocolList: [],
      groupList: [],
      lightType: ["单灯", "双灯"],
      steType: ["离线", "在线"],
      stateList:[
        {
          id: 0,
          name:"离线"
        },{
          id: 1,
          name:"在线"
        }
      ],
      steColorType: ["valuered", "valuegreen"],
      msType: ["(自动)", "(手动)"],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
        stg_id:'', //策略
        lamp_protocol: '1', //协议
        lamp_group: null, //灯组
        lamp_number: '', //编号
        lamp_name: '',//名称
        ste: ''//名称
      },
      cnt_all: 0,
      dialogVisible: false,
      lightSetItem: {
        lightSetVisible: false,
        title: "",
        lightSetData: {},
      },
      editType: -1,
      editLamp: {},
      editLampRule: {
        name: [{ required: false, message: "请输路灯名", trigger: "blur" }],
        address: [{ required: false, message: "请输入地址", trigger: "blur" }],
      },
      manualChange: false,
      allOpen: {
        visible: false,
        light: 0
      },
      exportFile: {
        visible: false,
        id: 1,
        file: '',
        lamp_type: '',
      },
      adminList: [],
      head_show: false,
      fileList: []
    };
  },
  methods: {
    getProtocolList() { // 获取协议列表
      lightListApi.getLampProtocol().then((res) => {
        if (res.data.code === 1000) {
          this.protocolList = res.data.data;
          if(this.protocolList.length>0){
            this.pageInfo.lamp_protocol = this.protocolList[0].id
          }
          this.getGroupList()
          this.getTableData(this.pageInfo.page);
        }
      });
    },
    getGroupList() { // 获取灯组列表
      lightGroupApi.lightGroupList({
        page: 1,
        pageSize: 200,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.groupList = resData.list;
        }
      });
    },
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightListApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    checkProtocel() {
      this.pageInfo = {
        page: 1,
        pageSize: 20,
        type: this.pageInfo.lamp_protocol
      }
      this.getTableData(this.pageInfo.page)
    },
    lightContorl (light) {
      if(light==1){
        light=this.allOpen.light
      }
      let sendData = {
        light: light,
        type: this.pageInfo.lamp_protocol,
      }
      lightListApi.lightControl(0,sendData).then(res => {
        if (res.data.code === 1000) {
          this.$message.success('下发成功')
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    deleteLamp(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lightListApi.lightDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    openEditWin(index) {
      if (index === "create") {
        this.editLamp = {
          lamp_type: null,
          number: '',
          name: '',
          address: '',
          sim: '',
          gateway: '',
          lamp_group: null,
          longitude: '',
          latitude: ''
        };
        
        let lngLat = store.state.user.account.center
        this.myMap.center = lngLat
        this.myMap.markercenter = lngLat

        this.editType = "create"
      } else {
        this.editLamp = {
          lamp_id: index.lamp_id,
          lamp_type: parseInt(index.lamp_type),
          number: index.number,
          name: index.name,
          address: index.address,
          sim: index.sim,
          gateway: index.gateway,
          lamp_group: parseInt(index.lamp_group),
          longitude: index.longitude,
          latitude: index.latitude
        };
        
        let lng = index.longitude
        let lat = index.latitude
        let lngLat = [lng, lat]
        if(!lng&&!lat){
          lngLat = store.state.user.account.center
        }
        this.myMap.center = lngLat
        this.myMap.markercenter = lngLat
        this.editType = "update"
      }
      this.dialogVisible = true;
    },
    updateItem() {
      lightListApi.lightEdit(this.editLamp.lamp_id, this.editLamp).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      lightListApi.lightAdd(this.editLamp).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    showSet(setting) {
      let query_data = {
        lamp_id: parseInt(setting.lamp_id),
        type: this.pageInfo.lamp_protocol,
        name: setting.name,
        stg_name: setting.stg_name,
        light: parseInt(setting.light),
        stg_id: parseInt(setting.stg_id),
        ms: parseInt(setting.ms),
      };
      this.lightSetItem.lightSetVisible = true;
      this.lightSetItem.title = setting.name;
      this.lightSetItem.lightSetData = query_data;
    },
    closeSet() {
      // 关闭编辑亮度
      let query_data = {
        id: "",
        name: "",
        stg_name: "",
        light: "",
        stg_id: "",
        ms: "",
      };
      this.lightSetItem.lightSetVisible = false;
      this.lightSetItem.title = "";
      this.lightSetItem.lightSetData = query_data;
      this.getTableData(this.pageInfo.page);
    },
    handleMove() {
      this.myMap.markercenter = this.$refs.map.$$getCenter();
      this.editLamp.longitude = this.myMap.markercenter[0];
      this.editLamp.latitude = this.myMap.markercenter[1];
    },
    changeSetHome(id, value) { //设置首页显示
      lightListApi.lightSetHome(id,{ type: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    changeAngle(id, value) { //设置倾斜角
      lightListApi.lightSetAngle(id,{ angle: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    headReset() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.pageInfo.stg_id = ''
      this.pageInfo.lamp_protocol = this.protocolList[0].id
      this.pageInfo.lamp_group = ''
      this.pageInfo.ste = ''
      this.pageInfo.lamp_number = ''
      this.pageInfo.lamp_name = ''
      this.getTableData(1)
    },
    selectChange(value) {
      if (value) {
        this.getTableData(this.pageInfo.page);
      } else {
        return value;
      }
    },
    onInput(){
      this.$forceUpdate();
    },
    headShow(show) {
      if(show){
        this.head_show = false
      }else{
        this.head_show = true
        this.getUserList()
      }
      
    },
    contorlType(type) {
      lightListApi.setAutoControl({
        type: type
      }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getUserList() {
      adminsApi.userList({
        page: 1,
        pageSize: 1000
      }).then((res) => {
        this.loading = false;
        let resData = res.data.data;
        this.adminList = resData.list
      });
    },
    exportExcel(type) {
      if(type==0){
        this.exportFile = {
          visible: false,
          id: 1,
          file: '',
          lamp_type: ''
        }
      }else{
        lightListApi.importExcel({
          id: this.exportFile.id,
          file: this.exportFile.file,
          lamp_type: this.exportFile.lamp_type
        }).then((res) => {
          if (res.data.code === 1000) {
            // this.$message.success(res.data.message);
            this.$alert(res.data.message, '提示', {
              confirmButtonText: '确定'
            });
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    uploadAction() {
      return process.env.VUE_APP_BASE_API+'/api/public/uploadFile';
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleAvatarSuccess(res, file) {
      console.log('handleAvatarSuccess',res)
      if (res.data.code === 1000) {
        this.$message.success("上传成功");
        this.exportFile.file = res.data.data.file_name;
      } else {
        this.$message.error("错误，" + res.data.message);
      }   
    },
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (testmsg==='xls'||testmsg==='xlsx') {
        return true;
      }else{{
        this.$message({
          message: "只能上传是Excel文件的格式！",
          type: "error",
        });
        return
      }}
      
    }
  },
  mounted() {
    this.getProtocolList()
  },
};
</script>
<style lang='less' scoped>
.lightList-content {
  width: 100%;

  .lamp-refresh {
    top: -10px;
  }
  .valuegreen {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: rgba(26, 151, 14, 0.856);
    border-radius: 50%;
    margin-right: 5px;
  }
  .valuered {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: rgba(241, 12, 4, 0.856);
    border-radius: 50%;
    margin-right: 5px;
  }
  .map-container {
    width: 100%;
    height: 292px;
    /* margin-bottom: 20px; */
  }

  .icon-error {
    background: url(/static/images/icons/error.png);
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: cover;
  }
}
.box_control {
  width: 600px !important;
  height: auto !important;
  margin-top: -200px !important;
  margin-left: -300px !important;
  .box_body {
    padding-bottom: 25px;
  }
}
.control{
  text-align: right;
}
.show_head{
  width:100%;
  height:28px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size:14px;
  cursor: pointer;
  i{
    margin-left:3px;
  }
}

.head_other{
  padding-top:10px;
  padding-bottom:20px;
}
.control_type{
  display: flex;
  align-items: center;
}
.other_text{
  color: #ccc;
  height:28px;
  display: flex;
  align-items: center;
  margin-right:10px;
  padding-left: 12px;
  font-size: 12px;
}
.other_text a{
  text-decoration: none;
  color:#0ccc8d
}


</style>

<style lang='less'>
.el-select-dropdown{
  .el-scrollbar{
    min-height:80px !important;
  }
}
</style>